// test1718
(1718 && 0);
